import React from 'react';

interface ActionButtonProps {
  content: string;
  icon: React.FC;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  content,
  icon,
  disabled,
}) => {
  return (
    <button
      className={`flex items-center gap-2 px-6 py-3 rounded-xl shadow-md border hover:bg-gray-50 text-[#1D67B6] font-medium ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      disabled={disabled}
    >
      {React.createElement(icon)}
      {content}
    </button>
  );
};

export default ActionButton;
